import withCheckbox from './withCheckbox'
import withSearch from './withSearch'
import Select from '.'

const SelectWithCheckbox = withCheckbox(Select)
const SelectWithCheckboxAndSearch = withSearch(SelectWithCheckbox)

export default SelectWithCheckboxAndSearch
